import { OrderByDirection, Timestamp } from '@angular/fire/firestore';
import { FirestoreDocument } from '../../libs/shared/models/firestore-document';

/**
 * Sorts an array of objects by a specified Timestamp property.
 *
 * @param array The array of items to sort
 * @param property Key of the object that must be of type Timestamp
 * @param direction Sort direction: 'asc' or 'desc'
 * @returns A new array sorted by the specified Timestamp property
 */
export function orderByTimestamp<T>(
  arr: FirestoreDocument<T>[],
  property: keyof {
    [K in keyof T as T[K] extends Timestamp ? K : never]: T[K];
  },
  direction: OrderByDirection = 'asc'
): FirestoreDocument<T>[] {
  return [...arr].sort((a, b) => {
    const timeA = (a.data[property] as Timestamp).toMillis();
    const timeB = (b.data[property] as Timestamp).toMillis();
    return direction === 'asc' ? timeA - timeB : timeB - timeA;
  });
}
